'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _trackerM = require('@beastshop/tracker-m');

var _trackerM2 = _interopRequireDefault(_trackerM);

var _request = require('../request');

var _request2 = _interopRequireDefault(_request);

var _util = require('../lib/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (options) {
  return new _promise2.default(function (resolve) {
    _util.adapter.invoke(resolve);
  }).then(function () {
    if (_util.adapter.env === 'miniprogram') {
      return track(options);
    }
    return (0, _trackerM2.default)(options);
  });
};

function track(_ref) {
  var name = _ref.name,
      _ref$attrs = _ref.attrs,
      attrs = _ref$attrs === undefined ? {} : _ref$attrs,
      _ref$wait = _ref.wait,
      wait = _ref$wait === undefined ? false : _ref$wait;

  if (!name) {
    console.error('tracker: name must not be empty');
    return _promise2.default.resolve();
  }
  var now = +new Date();
  var data = {
    n: name,
    p: '' + window.location.origin + window.location.pathname,
    tp: 'a',
    a: attrs,
    t: now,
    r: _util.query[_util.QUERY_REFERRER_NAME] || '',
    m: _util.query[_util.TBS_USOURCE_NAME] || ''
  };

  var id = '';
  try {
    id = JSON.parse(_util.query[_util.MEMBER_NAME]).id;
  } catch (e) {}
  var trackData = {
    t: now,
    d: btoa((0, _stringify2.default)(data)),
    m: id
  };
  console.log('sdk-track:', data, trackData);

  (0, _request2.default)({
    method: 'POST',
    url: '/_track/app',
    form: trackData
  }).catch(function (e) {});
  if (wait) {
    return new _promise2.default(function (resolve) {
      setTimeout(resolve, 200);
    });
  } else {
    return _promise2.default.resolve();
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/sdk/lib/track/index.js
// module id = 994
// module chunks = 0